// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"styles_subtitle__22X97","title":"styles_title__1T3UT"};